
<template>
  <v-application>
    <v-card class="ma-2">
      <v-card-title>
        <v-btn color="primary" class="my-2" @click="addOrder">
          {{ $t("add_order") }}
        </v-btn>
        <v-tabs fixed-tabs class="v-tabs-slider" @change="tabChanged">
          <v-tab
            style="border: solid lightgrey 0.5px"
            v-for="(workgroup, index) in workgroups"
            :key="index"
            >{{ workgroup.name }}
          </v-tab>
        </v-tabs>
      </v-card-title>
      <v-card-text>
        <v-data-table
          :loading="loading_w_orders"
          hide-default-footer
          disable-sort
          :headers="w_order_headers"
          :items="workgroup_orders"
          :no-data-text="no_data_text"
          :mobile-breakpoint="NaN"
          v-on:click:row="rowClicked"
        >
          <template v-slot:[`item.state`]="{ item }">{{
            $t(item.state)
          }}</template>
          <template v-slot:[`item.createdAt`]="{ item }">
            {{ date_ddmmyy_hhmm(item.createdAt) }}
          </template>
          <template v-slot:[`item.warning`]="{ item }">
            <v-icon color="error" v-if="item.is_waste">mdi-alert-circle</v-icon>
          </template>
        </v-data-table>
        <v-pagination v-model="workgroup_order_page" :length="total_workgroup_order"> </v-pagination>
      </v-card-text>
    </v-card>
    <v-dialog v-model="order_choosean" width="800">
      <v-card tile>
        <v-card-title>
          <p class="green--text ma-0 pa-0">
            Order № {{ currentWorkgroupOrder.order_number }}
          </p>
          <v-spacer />
          <v-btn
            v-if="
              currentWorkgroupOrder.employees &&
              !currentWorkgroupOrder.employees.length &&
              currentWorkgroupOrder.state == 'pending'
            "
            color="error"
            text
            @click="cancelCurrentOrder()"
          >
            <v-icon>mdi-close</v-icon>
            {{ $t("cancel") }}
          </v-btn>
          <v-btn
            text
            v-if="currentWorkgroupOrder.state == 'rejected'"
            @click="undoCurrentOrder()"
          >
            <v-icon>mdi-undo</v-icon>
            {{ $t("undo_rejecked") }}
          </v-btn>
          <v-btn v-if="currentWorkgroupOrder.state == 'completed'" color="primary" text @click="confirm_complete = true">
            {{ $t("confirm_complete") }}
          </v-btn>
          <v-btn icon class="ma-0 pa-0 ml-2" @click="order_choosean = false">
            <v-icon>mdi-close</v-icon>
          </v-btn>
        </v-card-title>
        <v-card-text class="px-5">
          <!-- Client -->
          <p
            class="green--text ma-0 pa-0 font-weight-medium"
            style="margin-left: -5px"
          >
            {{ $t("client") }}
          </p>
          <v-layout row>
            <v-flex px-3 md6 sm12 xs12>
              <label>{{ $t("name") }}</label>
            </v-flex>
            <v-flex px-3 md6 sm12 xs12>
              <label>{{
                currentWorkgroupOrder.client
                  ? currentWorkgroupOrder.client.first_name
                  : ""
              }}</label>
            </v-flex>
          </v-layout>
          <v-divider class="my-2"></v-divider>
          <v-layout row>
            <v-flex px-3 md6 sm12 xs12>
              <label>{{ $t("phone_number") }}</label>
            </v-flex>
            <v-flex px-3 md6 sm12 xs12>
              <label>{{
                currentWorkgroupOrder.client
                  ? currentWorkgroupOrder.client.phone_number
                  : ""
              }}</label>
            </v-flex>
          </v-layout>
          <v-divider class="my-2"></v-divider>

          <!-- Info -->
          <p class="green--text ma-0 pa-0 font-weight-medium">
            {{ $t("info") }}
          </p>
          <v-layout row>
            <v-flex px-3 md6 sm12 xs12>
              <label class="caption">{{ $t("state") }}</label
              ><br />
              <label class="black--text">{{
                $t(currentWorkgroupOrder.state)
              }}</label>
            </v-flex>
            <v-flex px-3 md6 sm12 xs12>
              <label class="caption">{{ $t("title") }}</label
              ><br />
              <label class="black--text">{{
                currentWorkgroupOrder.title
              }}</label>
            </v-flex>
          </v-layout>
          <v-layout row>
            <v-flex px-3 md6 sm12 xs12>
              <label class="caption">{{ $t("date_created") }}</label
              ><br />
              <label class="black--text">{{
                date_ddmmyy_hhmm(currentWorkgroupOrder.createdAt)
              }}</label>
            </v-flex>
            <v-flex px-3 md6 sm12 xs12>
              <label class="caption">{{ $t("store") }}</label
              ><br />
              <label class="black--text">{{
                currentWorkgroupOrder.service_name
              }}</label>
            </v-flex>
          </v-layout>
          <v-divider class="my-2"></v-divider>
          <v-layout row>
            <v-flex px-3 md6 sm12 xs12>
              <label class="caption">{{ $t("comment") }}</label
              ><br />
              <label class="black--text">{{
                currentWorkgroupOrder.comment
              }}</label>
            </v-flex>
            <v-flex px-3 md3 sm12 xs12>
              <label class="caption">{{ $t("total") }}</label
              ><br />
              <label class="black--text">
                {{
                  currentWorkgroupOrder.total_cost
                    ? currentWorkgroupOrder.total_cost.toLocaleString()
                    : currentWorkgroupOrder.total_cost
                }}
              </label>
            </v-flex>
            <v-flex px-3 md3 sm12 xs12>
              <label class="caption">{{ $t("total_actual_cost") }}</label
              ><br />
              <label class="black--text">
                {{
                  currentWorkgroupOrder.total_actual_cost
                    ? currentWorkgroupOrder.total_actual_cost.toLocaleString()
                    : currentWorkgroupOrder.total_actual_cost
                }}
              </label>
            </v-flex>
          </v-layout>
          <v-divider
            v-if="currentWorkgroupOrder.comment != ''"
            class="my-2"
          ></v-divider>

          <!-- Workgroups -->
          <v-stepper
            v-model="currentWorkgroupOrder.active_workgroup_order"
            vertical
            light
            :elevation="0"
          >
            <p class="green--text ma-0 pa-0 ml-5 font-weight-medium">
              {{ $t("workgroups") }}
            </p>
            <template
              v-for="(w_name, n) in currentWorkgroupOrder.workgroup_names"
            >
              <v-stepper-step
                :key="`${n + 1}-step`"
                :step="n + 1"
                color="success"
              >
                <v-list-item class="ma-0 pa-0">
                  <v-list-item-title>
                    {{ w_name.name }}
                  </v-list-item-title>
                </v-list-item>
              </v-stepper-step>
              <v-stepper-items :key="n" class="my-0 pa-0">
                <v-list v-if="w_name.employee" class="px-5 mx-5 my-0 py-0">
                  <v-list-item class="ma-0 pa-0">
                    <v-list-item-content class="ma-0 pa-0">
                      {{ w_name.employee.employee_name }} -
                      {{ $t(w_name.employee.state) }}
                    </v-list-item-content>
                  </v-list-item>
                </v-list>
              </v-stepper-items>
              <v-stepper-content
                :key="`${n + 1}-content`"
                :step="n + 1"
                class="py-1"
              >
                <div class="font-weight-bold black--text">
                  {{ $t(currentWorkgroupOrder.state) }}
                </div>
              </v-stepper-content>
            </template>
          </v-stepper>
          <v-data-table
            :headers="item_headers"
            disable-sort
            hide-default-footer
            :items="currentWorkgroupOrder.items"
          >
            <template v-slot:[`item.waste`]="{ item }">
              <v-icon color="error" v-if="item.quantity < item.used_quantity"
                >mdi-alert-circle</v-icon
              >
            </template>
          </v-data-table>
        </v-card-text>
      </v-card>
    </v-dialog>
    <v-dialog v-model="confirm_complete" persistent width="500">
      <v-card>
        <v-card-title>{{ $t("confirm_complete") }}</v-card-title>
        <v-card-text>
          <v-layout row px-2>
            <v-flex px-2 md6>
              <vuetify-money
                :label="$t('total_cost')"
                v-model="currentWorkgroupOrder.total_actual_cost"
                v-bind:options="moneyOptions"
                readonly
              />
            </v-flex>
            <v-flex px-2 md6>
              <vuetify-money
                :label="$t('additional')"
                v-model="additional"
                v-bind:options="moneyOptions"
              />
            </v-flex>
          </v-layout>
          <v-layout row px-2>
            <v-flex px-2 md6>
              <v-select
                v-model="payment_type"
                :label="$t('payment_type')"
                :items="payment_types"
              />
            </v-flex>
            <v-flex px-2 md6>
              <vuetify-money
                :label="$t('total_amount')"
                v-model="total_amount"
                v-bind:options="moneyOptions"
                readonly
              />
            </v-flex>
          </v-layout>
        </v-card-text>
        <v-card-actions>
          <v-spacer />
          <v-btn :disabled="confirm_loading" text @click="confirm_complete = false">{{
            $t("cancel")
          }}</v-btn>
          <v-btn :loading="confirm_loading" text color="primary" @click="confirmCurrentOrder">{{ $t("confirm") }}</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-application>
</template>

<script>
import Workgroups from "../../mixins/employees/workgroup";
import WorkgroupOrder from "../../mixins/employees/workgroup_order";

export default {
  name: "workgroup-orders",
  mixins: [Workgroups, WorkgroupOrder],
  data: () => ({
    loading_w_orders: false,
    currentWorkgroupOrder: {
      employees: [],
    },
    order_choosean: false,
    additionalOrders: true,
    stepper: 2,
    active_tab: -1,
    confirm_complete: false,
    additional: 0,
    payment_type: 'cash',
    total_amount: 0,
    confirm_loading: false
  }),
  watch: {
    additional() {
      if(this.currentWorkgroupOrder) {
        this.total_amount = +this.currentWorkgroupOrder.total_actual_cost + +this.additional;
      }
    },
    'currentWorkgroupOrder.total_actual_cost'() {
      if(this.currentWorkgroupOrder) {
        this.total_amount = +this.currentWorkgroupOrder.total_actual_cost + +this.additional;
      }
    },
    workgroup_order_page() {
      this.tabChanged(this.active_tab, false)
    }
  },
  computed: {
    payment_types() {
      return [
        { text: this.$t('cash'), value: 'cash' },
        { text: this.$t('card'), value: 'card' },
        { text: this.$t('debt'), value: 'debt' }
      ]
    },
    no_data_text() {
      return this.$t("no_workgroup_orders");
    },
    w_order_headers() {
      return [
        { text: "№", value: "order_number", width: 150 },
        { text: this.$t("title"), value: "title" },
        { text: this.$t("count"), value: "order_item_count", align: 'right' },
        { text: this.$t("state"), value: "state", align: 'right', width: 200 },
        {
          text: this.$t("created_date"),
          value: "createdAt",
          width: 150,
          align: "right",
        },
        { text: null, value: "warning", width: 30, align: "center" },
      ];
    },
    item_headers() {
      return [
        { text: this.$t("name"), value: "product_name" },
        {
          text: this.$t("used_quantity"),
          value: "used_quantity",
          width: 120,
          align: "right",
        },
        {
          text: this.$t("quantity"),
          value: "quantity",
          width: 120,
          align: "right",
        },
        { text: this.$t("cost"), value: "cost", width: 120, align: "right" },
        { text: null, value: "waste", width: 50, align: "center" },
      ];
    },
  },
  methods: {
    async tabChanged(num, page_changed = true) {
      if(page_changed) {
        this.workgroup_order_page = 1
      }
      this.active_tab = num;
      this.loading_w_orders = true;
      if (this.workgroups && this.workgroups[num]) {
        await this.getWorkgroupOrderList(this.workgroups[num]._id);
      }
      this.loading_w_orders = false;
    },
    addOrder() {
      this.$router.push("/inventory/workgroup/orders/create").catch(() => {});
    },
    async rowClicked(item) {
      this.$router.push(`/inventory/workgroup/orders/detail?id=${item._id}`).catch(()=>{});
    },
    async cancelCurrentOrder() {
      this.order_choosean = false;
      this.loading_w_orders = true;
      await this.cancelWorkgroupOrder(this.currentWorkgroupOrder._id);
      this.tabChanged(this.active_tab, false);
    },
    async undoCurrentOrder() {
      this.order_choosean = false;
      this.loading_w_orders = true;
      await this.undoWorkgroupOrder(this.currentWorkgroupOrder._id);
      this.tabChanged(this.active_tab, false);
    },
    async confirmCurrentOrder() {
      this.confirm_loading=true;
      await this.confirmWorkgroupOrder(
        this.currentWorkgroupOrder._id,
        {
          additional: this.additional,
          payment_type: this.payment_type
        }
      );
      const result = await this.getWorkgroupOrderById(this.currentWorkgroupOrder._id)
      if(result) {
        this.currentWorkgroupOrder = result;
      }
      this.total_amount = 0;
      this.confirm_loading=false;
      this.confirm_complete=false;
      this.tabChanged(this.active_tab, false)
    }
  }
};
</script>

<style scoped>
.multi-line-truncate {
  display: -webkit-box;
  -webkit-box-orient: vertical;
  -webkit-line-clamp: 3;
  overflow: hidden;
}
.v-btn {
  background-color: #e9f6e7 !important;
  text-transform: none !important;
}
.v-tab {
  text-transform: none !important;
}
.v-tabs-slider-wrapper .v-tabs-slider {
  background-color: none !important;
  height: 0;
}
.v-tab--active {
  color: white !important;
  background-color: #3e6187;
}
</style>
